<template>
  <div class="mb-4 p-3 border rounded">
    <h2>Рекомендации рецептов (тест)</h2>

    <!-- Form for user input -->
    <form @submit.prevent="getSuggestion" class="form">
      <!-- Prompt imeal type -->
      <div class="mt-3">
        <label for="mealType" class="form-label">Тип приема пищи:</label>
        <select id="mealType" class="form-select" v-model="mealType">
          <option value="завтрак">Завтрак</option>
          <option value="обед">Обед</option>
          <option value="ужин">Ужин</option>
        </select>
      </div>

      <!-- Prompt offset -->
      <div class="mt-3">
        <label for="offset" class="form-label">Смещение (offset):</label>
        <input
          type="number"
          id="offset"
          class="form-control"
          v-model.number="offset"
          min="0"
        />
      </div>

      <!-- Buttons  -->
      <div class="mt-3 d-flex align-items-center">
        <button
          @click="getSuggestion"
          class="btn btn-outline-success"
          :disabled="isLoading"
        >
          {{ isLoading ? "Загрузка..." : "Получить рекомендацию" }}
        </button>

        &nbsp;

        <!-- Next button -->
        <div class="">
          <button
            @click="getSuggestionNext"
            class="btn btn-outline-secondary"
            :disabled="isLoading || !currentSuggestion"
          >
            Ещё (следующая)
          </button>
        </div>
      </div>
    </form>

    <!-- Loading Spinner -->
    <div v-if="isLoading" class="d-flex justify-content-center mt-3 mb-3">
      <div
        class="spinner-border text-primary"
        role="status"
        style="width: 3rem; height: 3rem"
      >
        <span class="visually-hidden">Загрузка...</span>
      </div>
    </div>
    <!-- End Loading Spinner -->

    <div
      v-if="
        !isLoading &&
        currentSuggestion === null &&
        !error &&
        !noMoreSuggestions &&
        !initialLoad
      "
      class="mt-3 fst-italic text-muted"
      role="alert"
    >
      Введите UID, выберите тип приема пищи и нажмите "Получить рекомендацию".
    </div>

    <div v-if="error" class="mt-3 text-danger" role="alert">
      {{ error }}
    </div>

    <div v-if="currentSuggestion" class="suggestion-result card mt-3">
      <div class="card-header">
        <h3>Предложенный рецепт:</h3>
      </div>
      <div class="card-body">
        <pre>{{ currentSuggestion }}</pre>
        <!-- Здесь можно будет использовать RecipeView для красивого отображения -->
        <!-- <RecipeView :recipe="parsedSuggestion" v-if="parsedSuggestion" /> -->
      </div>
    </div>

    <div v-if="noMoreSuggestions" class="alert alert-warning mt-3" role="alert">
      Больше предложений по этому запросу нет.
    </div>
  </div>
</template>

<script>
const CMD_RECIPE_SUGGEST_FOR_MEAL = "recipe.suggest";

export default {
  name: "RecipeSuggestions",

  data() {
    return {
      uid: "123-654-789", // Will be set in created()
      mealType: "завтрак",
      offset: 0,
      isLoading: false,
      error: null,
      currentSuggestion: null, // For JSON-answer from server
      // parsedSuggestion: null, // For parsed recipe, if necessary
      noMoreSuggestions: false,
      initialLoad: true, // To prevent initial message from showing before first load attempt
    };
  },

  mounted() {
    let that = this;

    this.reader = this.teoweb.addReader(function (gw, rawData) {
      if (gw.err) {
        // Only handle errors if this component initiated loading
        if (that.isLoading) {
          if (gw.err != "access-denied") {
            that.message = "";
            that.error = "Ошибка: " + gw.err;
          }
          that.isLoading = false;
        }
        return;
      }

      // Process CMD_RECIPE_SUGGEST_FOR_MEAL answer
      if (gw.command.startsWith(CMD_RECIPE_SUGGEST_FOR_MEAL)) {
        that.isLoading = false;
        try {
          const data = JSON.parse(rawData);
          if (
            data.message &&
            data.message === "No more suggestions available"
          ) {
            that.noMoreSuggestions = true;
            that.currentSuggestion = null;
          } else if (data.id && (data.title || data.name)) {
            // Check for title OR name
            that.currentSuggestion = JSON.stringify(data, null, 2); // Display raw JSON
            that.noMoreSuggestions = false;
          } else {
            console.error("Unexpected response format:", data);
            that.error = "Получен неожиданный формат ответа от сервера."; // UI message in Russian
            that.currentSuggestion = JSON.stringify(data, null, 2); // Show raw response
          }
        } catch (e) {
          console.error("Error parsing server response:", e, rawData);
          that.error = "Ошибка обработки ответа от сервера."; // UI message in Russian
          that.currentSuggestion = rawData; // Show raw response on parsing error
        }
      }
    });
  },

  unmounted() {
    this.teoweb.delReader(this.reader);
  },

  methods: {
    getSuggestion() {
      if (!this.uid || !this.mealType) {
        this.error = "UID и тип приема пищи должны быть указаны."; // UI message in Russian
        return;
      }
      if (!this.teoweb) {
        this.error = "Teoweb не инициализирован."; // UI message in Russian
        return;
      }

      this.error = null;
      this.isLoading = true;
      this.currentSuggestion = null;
      this.noMoreSuggestions = false;
      this.initialLoad = false;

      const today = new Date().toISOString().slice(0, 10);
      const command = `${CMD_RECIPE_SUGGEST_FOR_MEAL}/${this.mealType}/${
        this.offset
      }/${encodeURIComponent(today)}`;
      console.log(`Sending command: ${command}`);

      this.teoweb.sendCmd(command);
    },

    getSuggestionNext() {
      if (this.noMoreSuggestions) return;
      this.offset += 1;
      this.getSuggestion();
    },
  },
};
</script>

<!-- The <style scoped> block was removed, assuming Bootstrap is used for styling -->
